import { useEffect } from "react";

export const MEASUREMENT_UPLOAD_TOAST_EVENT = "measurement-upload-toast";

const STORAGE_KEY = "measurementUploadToasts";

const readNotifications = () => {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const writeNotifications = (notifications) => {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(notifications));
};

export const notifyMeasurementUploadToast = ({
  message,
  severity = "success",
}) => {
  const notification = {
    id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
    message,
    severity,
  };

  writeNotifications([...readNotifications(), notification]);
  window.dispatchEvent(
    new CustomEvent(MEASUREMENT_UPLOAD_TOAST_EVENT, {
      detail: notification,
    }),
  );
};

export const consumeMeasurementUploadToasts = () => {
  const notifications = readNotifications();
  sessionStorage.removeItem(STORAGE_KEY);
  return notifications;
};

export const acknowledgeMeasurementUploadToast = (id) => {
  if (!id) return;
  writeNotifications(
    readNotifications().filter((notification) => notification.id !== id),
  );
};

export const useMeasurementUploadToasts = (showToast) => {
  useEffect(() => {
    consumeMeasurementUploadToasts().forEach(showToast);

    const handleToast = (event) => {
      const notification = event.detail;
      if (!notification) return;
      acknowledgeMeasurementUploadToast(notification.id);
      showToast(notification);
    };

    window.addEventListener(MEASUREMENT_UPLOAD_TOAST_EVENT, handleToast);
    return () => {
      window.removeEventListener(MEASUREMENT_UPLOAD_TOAST_EVENT, handleToast);
    };
  }, [showToast]);
};
